module.exports = __webpack_public_path__ + "img/Renault.0e25db94.png";